module.exports = __webpack_public_path__ + "static/media/CelebrateCap.5ce51664.svg";